import type { SafeBooking } from "@playarena/shared";
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { BookingState } from "@/types/booking";

const initialState: BookingState = {
  bookings: [],
  currentBooking: null,
  selectedSeats: [],
  isLoading: false,
  error: null,
};

const bookingSlice = createSlice({
  name: "booking",
  initialState,
  reducers: {
    setSelectedSeats: (state, action: PayloadAction<string[]>) => {
      state.selectedSeats = action.payload;
    },
    addSelectedSeat: (state, action: PayloadAction<string>) => {
      if (!state.selectedSeats.includes(action.payload)) {
        state.selectedSeats.push(action.payload);
      }
    },
    removeSelectedSeat: (state, action: PayloadAction<string>) => {
      state.selectedSeats = state.selectedSeats.filter(seat => seat !== action.payload);
    },
    clearSelectedSeats: state => {
      state.selectedSeats = [];
    },
    setCurrentBooking: (state, action: PayloadAction<SafeBooking | null>) => {
      state.currentBooking = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
  },
});

export const {
  setSelectedSeats,
  addSelectedSeat,
  removeSelectedSeat,
  clearSelectedSeats,
  setCurrentBooking,
  clearError,
  setLoading,
  setError,
} = bookingSlice.actions;
export default bookingSlice.reducer;
